module.exports = __webpack_public_path__ + "static/media/setpoint-CWU-grzanie.5bd6eb88.svg";